import React from 'react'
import '../spinner/Spinner.scss'

function Spinner() {
    return (
        <>
          <div className="spinner_dashboard">
          <div className="spinner dotted"></div>
          </div> 
        </>
    )
}

export default Spinner